export const addScript = (attributes) => {
  const el = document.createElement('script');
  attributes.forEach(({ key, value }) => {
    el.setAttribute(key, value);
  });
  document.head.appendChild(el);
};
